import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { dashboardKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import { showDashboardContract, type ShowDashboardResponse } from '@bliks-io/contracts';

export function useDashboard() {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: dashboardKeys.all,
    queryFn: async ({ signal }): Promise<ShowDashboardResponse> => {
      const { data } = await apiClient.get<ShowDashboardResponse>(showDashboardContract.path, {
        signal
      });
      return data;
    },
    enabled: !!token
  });
}
